import { A11yPageListItem } from '@wix/rules-panel-ui';
import React from 'react';
import { usePageListItemBase } from './use-page-list-item-base';
export const PageListItemButton = /*#__PURE__*/React.memo(_ref => {
  let {
    pageId,
    isPageOpen
  } = _ref;
  const itemProps = usePageListItemBase({
    isPageOpen,
    isTpaPage: true,
    pageId
  });
  return /*#__PURE__*/React.createElement(A11yPageListItem, itemProps);
});
//# sourceMappingURL=page-list-item-button-wrapper.js.map